import { FC } from "react";

import s from "./Paragraph.module.scss";

interface Props {
  children: React.ReactNode;
}

export const Paragraph: FC<Props> = ({ children }) => <div className={s.Paragraph}>{children}</div>;
